import React from 'react';
import { Bar } from './bar';

import style from './comparison-bars.module.scss';

const ComparisonBars = ({
  values = [],
  opposite = [],
  num = 1,
  min = 0,
  max = 100,
  segmentWidth = 10,
  unitSign = '',
  comparisonType = '',
  setRoundName = true
}) => {
  const rounds = Array.from(Array(num).keys());
  const roundName = ['1st', '2nd', '3rd', '4th'];

  return (
    <div className={style.comparisonContainer}>
      {rounds.map((_, index) => (
        <div key={index} className={style.comparison}>
          <div className={style.barWrapper}>
            <Bar
              side={'left'}
              value={values[index] || 0}
              opposite={opposite[index] || 0}
              min={min}
              max={max}
              segmentWidth={segmentWidth}
              withValues={index + 1 === num}
              unitSign={unitSign}
              empty={!Boolean(values[index])}
            />
          </div>
          <div className={style.round}>
            {setRoundName && roundName[index]}
            {index + 1 === num && (
              <>
                <br />
                <span className={style.comparisonType}>{comparisonType}</span>
              </>
            )}
          </div>
          <div className={style.barWrapper}>
            <Bar
              side={'right'}
              value={opposite[index] || 0}
              opposite={values[index] || 0}
              min={min}
              max={max}
              segmentWidth={segmentWidth}
              withValues={index + 1 === num}
              unitSign={unitSign}
              empty={!Boolean(opposite[index])}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export { ComparisonBars };
